import React, { Component } from 'react'
import CAAccess from '../CreateApplet/CAAccess'
import FramePermissions from '../CreateApplet/FramePermissions'
import CAPermissions from '../CreateApplet/CAPermissions'
import CAHeader from '../../components/header/CAHeader'
import ButtonAnimated from '../../components/buttons/ButtonAnimated'
import { translate } from '../../utils/useful'

export default class PermissionsPage extends Component {

    state = {

    }

    setData = (key, value, reference, cb) => {
        
        // console.log(key, value, reference)
        if (reference == 'PermissionsPage') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {

                })
            }
        }
    }
    componentDidMount() {
        if (this.setHeader) {
            this.setHeader({
                'toolbar': null,
                'showToolbar': false,
                // 'title': `${this.props.user?.info?.fullname}`,
                'info': 'Create Applet | Manage Access',
                topHeaderComponent: this.topHeaderComponent,
                backAction: () => this.props.lastStage()

            })
        }
    }



    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: 'static'
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }


    topHeaderComponent = () => {
        return (
            <div className='flexc'>

                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.nextStage}
                    isLoading={this.state.isLoading}
                    title={translate("ca.Continue")}
                    icon='/assets/icons/angle-right-white2.svg'
                    textColor={'#222'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />

            </div>

        )
    }

    nextStage = () => {
        // let data = {
        //     admins: this.state.admins,
        // }
        // if (data) {
        //     this.props.setData({ permissions: data }, () => {
        if (this.props.continue) {
            this.props.continue(this.props.stageName)
        } else {
            this.props.changeStage('access')
        }
        // })
        // }
    }


    render() {

        // console.log("this.props.variables",this.props.variables)
        return (
            <div className='h-100'>

                {this.props.forApplet && (
                    <CAAccess continue={this.nextStage} initData={this.props.initData} frames={this.props.frames} language={this.props.settings?.language} setData={this.setData} width={this.props.width} changeStage={this.props.changeStage} lastStage={this.props.lastStage} colors={this.props.colors} setHeader={this.props.setHeader} variables={this.props.variables} />
                    // <CAPermissions initData={this.props.initData} language={this.props.settings?.language} setData={this.setData} width={this.props.width} changeStage={this.props.changeStage} lastStage={this.props.lastStage} colors={this.props.colors} />
                )}
                {!this.props.forApplet && (
                    <FramePermissions continue={this.nextStage} baseUrl={this.props.baseUrl} initData={this.props.initData} frames={this.props.frames}  postCollection={this.props.postCollection} type={'FramePermissions'} language={this.props.language} lastStage={this.props.lastStage} setHeader={this.props.setHeader} colors={this.props.colors} windowData={this.props.windowData} page={this.props.page} submitCollection={this.props.submitCollection} data={this.props.data} setData={this.setData} changeStage={this.props.changeStage} lastStagePage={this.props.lastStagePage} applet={this.props.applet} pages={this.props?.pages} width={this.props.width} height={this.props.height} stage={1} user={this.props.user} modules={this.props.modules} stageName={'FramePermissions'} changePage={this.props.changeStage} title={"Continue"} description={"Frame access"} route={this.props.route} variables={this.props.variables} functionsHandler={this.props.functionsHandler} changeWindowLink={this.props.changeWindowLink} />
                )}
            </div>
        )
    }
}
